package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSAuthenticatedRequestBuilder
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.pathParamFollowing
import com.fsryan.foundation.net.client.replacePathParams

/**
 * `POST /api/v1/sharedMixes/{id}/preview`: renders a shared mix's preview image again. Only its owner may (404
 * otherwise); 409 while a recent request is still rendering; 202 when started.
 */
class WMRegenerateSharedMixPreviewRequestBuilder:
    FSAuthenticatedRequestBuilder<WMRegenerateSharedMixPreviewRequestBuilder, Nothing>() {

    private var sharedMixId: String? = null

    fun sharedMixId(sharedMixId: String): WMRegenerateSharedMixPreviewRequestBuilder {
        this.sharedMixId = sharedMixId
        return this
    }

    override fun applyFrom(request: FSRequest<Nothing>): WMRegenerateSharedMixPreviewRequestBuilder {
        sharedMixId = request.pathParamFollowing("sharedMixes")
        return super.applyFrom(request)
    }

    override fun build(): FSRequest<Nothing> {
        method(FSRequest.Method.Post)
        val id = sharedMixId ?: error("A shared mix id must be provided")
        replacePathParams("api", "v1", "sharedMixes", id, "preview")
        return super.build()
    }

    override fun clear(): WMRegenerateSharedMixPreviewRequestBuilder {
        sharedMixId = null
        return super.clear()
    }

    override fun self(): WMRegenerateSharedMixPreviewRequestBuilder = this
}
